import React from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";

import cross_dark_icon from "../../../assets/images/icons/cross_dark_icon.png";

export default function ViewTicketDetailModalHelpSupportComponent(props) {
  const { isOpen, onClose, data } = props;

  console.log(data);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <div className="flex flex-row gap-2">
            <div className="h-6 w-6  flex flex-col justify-center ">
              {/* <img src={support_dark_icon} /> */}
            </div>

            <h4>View Support Ticket</h4>
          </div>
          <ModalCloseButton />
        </ModalHeader>

        <ModalBody sx={{ padding: "2rem" }}>
          <div className="flex flex-col gap-8">
            <div className="">
              <h4 className="mb-2">Subject</h4>
              <p>{data.support_ticket_title}</p>
            </div>
            <div className="">
              <h4 className="">Description</h4>
              <div className="h-[35vh] overflow-y-auto mt-2 ">
                <p style={{ whiteSpace: "pre-wrap" }}>
                  {data.support_ticket_description}
                </p>
              </div>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <div className="flex flex-row justify-end gap-2">
            <div className="h-[3.13]">
              <Button
                sx={{ height: "3.13rem" }}
                variant="outline"
                onClick={onClose}
              >
                <img className="mr-2" src={cross_dark_icon} /> Close
              </Button>
            </div>
          </div>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
